import { captureException, captureMessage } from 'error_tracker';

/**
 * Using localStorage but we could enhance to fallback to Cookies later 🍪
 * Usage:
 * ```
 * const storage = new JsonStorage('STORAGE_NAME')
 * storage.save(jsonObject)
 * const value = storage.get()
 * storage.remove()
 * ```
**/
export default class JsonStorage {
	/**
	 *
	 * @param {str} name - key of storage item
	 * @param {bool} session - when true, uses sessionStorage
	 */
	constructor (name, session = false) {
		this.name = name;
		this.session = session;
		return this;
	}

	get = () => {
		const myStorage = this.session ? sessionStorage : localStorage;
		let value = myStorage['getItem'](this.name);
		try {
			let val = JSON.parse(value);
			return val;
		} catch (e) {
			// its bad data, get rid of it
			captureException(e);
			captureMessage(`Bad data for JsonStorage item ${name}`);
			this.remove();
			return;
		}
	}

	save = (value) => {
		if (!value) return;
		const myStorage = this.session ? sessionStorage : localStorage;
		myStorage['setItem'](this.name, JSON.stringify(value));
	}

	remove = () => {
		const myStorage = this.session ? sessionStorage : localStorage;
		myStorage['removeItem'](this.name);
	}
}

/**
 * Export for Backbone bc I can't call the constructor over there
 * maybe I could via `export.default` but that's weirder IMO
 */
export const getInstance = (...args) => {
	return new JsonStorage(...args);
};
